export const ROOT_SECURITY_STATE = 'security';

export const INITIAL_STATE = {
  groups: [],
  retrieveInProgress: false,
  error: undefined
};
